import React from 'react';

import ModalHeader from '@atlaskit/modal-dialog/modal-header';
import ModalTitle from '@atlaskit/modal-dialog/modal-title';
import { Box } from '@atlaskit/primitives/box';
import { xcss } from '@atlaskit/primitives/xcss/xcss';
import VisuallyHidden from '@atlaskit/visually-hidden/visually-hidden';

import SearchInput from './input';

const headerInputWrapperStyles = xcss({
	flex: '1 1 auto',
});

export type SearchModalHeaderProps = {
	testId?: string;
	onQueryChange(value: string): void;
	onKeyDown: React.KeyboardEventHandler<HTMLInputElement>;
	inputRef: React.RefObject<HTMLInputElement>;
	isExpanded: boolean;
	listboxId: string;
	activeDescendantId?: string;
	onRefineReady?: (refine: (query: string) => void) => void;
};

/**
 * __Search modal header__
 *
 * Header for the search modal, including the search input and close button.
 *
 */
export const SearchModalHeader = ({
	testId,
	onQueryChange,
	onKeyDown,
	inputRef,
	isExpanded,
	listboxId,
	activeDescendantId,
	onRefineReady,
}: SearchModalHeaderProps): React.JSX.Element => (
	<ModalHeader hasCloseButton>
		<Box xcss={headerInputWrapperStyles}>
			<VisuallyHidden>
				<ModalTitle>Search</ModalTitle>
			</VisuallyHidden>
			<SearchInput
				testId={testId}
				onQueryChange={onQueryChange}
				onKeyDown={onKeyDown}
				inputRef={inputRef}
				isExpanded={isExpanded}
				listboxId={listboxId}
				activeDescendantId={activeDescendantId}
				onRefineReady={onRefineReady}
			/>
		</Box>
	</ModalHeader>
);
